import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {
  getPDFPages,
  tryGetPDFPages,
  setPDFCarouselIndex,
  setIsPdfTagActive,
  unsetIsPdfTagActive,
  unsetPdfTagClicked,
  restorePreviosPdfCarrouselIndexSuccess
} from "../../actions/CommentAction";
import { PAGINATION_SIZE } from "../../utils";
import PDFViewPresentational from "./PDFViewPresentational";

export class PDFViewContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      exploreIndex: 0,
      currentPage: 1,
      navigateInput: 1,
      isUpdatingFromTag: false
    };
  }

  componentDidMount() {
    this.flkty.on("settle", this.onSettleFlickity);
  }

  onSettleFlickity = () => {
    const { itemSelected, intl, isFetchingPages, tryGetPDFPages } = this.props;

    // this.flkty.on('settle', () => {
    this.setState({ exploreIndex: this.flkty.selectedIndex }, () => {
      if (
        !isFetchingPages &&
        (this.flkty.selectedIndex + 1) % PAGINATION_SIZE === 0 &&
        itemSelected.document.documentPages.length <
          itemSelected.document.totalDocumentPages
      ) {
        const skipPage =
          (Number(this.flkty.selectedIndex) + 1) / PAGINATION_SIZE + 1;

        tryGetPDFPages(
          intl,
          itemSelected.document.client,
          itemSelected.document._id,
          skipPage
        );
      }
    });
    // })
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      isPdfTagClicked,
      unsetPdfTagClicked,
      selectedIndex,
      newPdfCarouselIndex,
      previousPdfCarouselIndex,
      isSettingPrevious,
      restorePreviosPdfCarrouselIndexSuccess
    } = this.props;
    const { isPdfTagClicked: prevIsPdfTagClicked } = prevProps;
    if (
      isPdfTagClicked &&
      !prevIsPdfTagClicked &&
      newPdfCarouselIndex &&
      selectedIndex !== newPdfCarouselIndex
    ) {
      this.handlerSelectFlickity(newPdfCarouselIndex - 1);
      unsetPdfTagClicked();
    }
    if (isSettingPrevious && selectedIndex === previousPdfCarouselIndex) {
      restorePreviosPdfCarrouselIndexSuccess().then(() => {
        this.handlerSelectFlickity(selectedIndex - 1);
      });
    }
  }

  handlerSelectFlickity = index => {
    const { getPDFPages, setPDFCarouselIndex, itemSelected, intl } = this.props;
    const limit =
      Number(index) + (PAGINATION_SIZE - (Number(index) % PAGINATION_SIZE));
    this.setState(
      { exploreIndex: index, currentPage: index + 1, navigateInput: index + 1 },
      () => {
        this.flkty.select(index);
        setPDFCarouselIndex(index + 1).then(() => {
          if (
            Number(index) + 1 > itemSelected.document.documentPages.length &&
            itemSelected.document.documentPages.length !==
              itemSelected.document.totalDocumentPages
          ) {
            getPDFPages(
              intl,
              itemSelected.document.client,
              itemSelected.document._id,
              0,
              limit
            )
              .then()
              .catch();
          }
        });
      }
    );
  };

  handleonKeyUp = event => {
    const { getPDFPages, setPDFCarouselIndex, itemSelected, intl } = this.props;
    const index =
      event.target.value > itemSelected.document.totalDocumentPages
        ? itemSelected.document.totalDocumentPages
        : event.target.value < 1
        ? 1
        : event.target.value;
    const limit =
      Number(index) + (PAGINATION_SIZE - (Number(index) % PAGINATION_SIZE));

    if (event.key === "Enter") {
      this.setState(
        {
          exploreIndex: index,
          currentPage: Number(index),
          navigateInput: Number(index)
        },
        () => {
          setPDFCarouselIndex(index);
          if (
            itemSelected.document.documentPages.length !==
            itemSelected.document.totalDocumentPages
          ) {
            getPDFPages(
              intl,
              itemSelected.document.client,
              itemSelected.document._id,
              0,
              limit
            )
              .then(() => {
                this.flkty.select(index - 1);
              })
              .catch();
          } else {
            this.flkty.select(index - 1);
            setPDFCarouselIndex(index);
          }
        }
      );
    }
  };

  handleOnChange2 = event => {
    const { itemSelected } = this.props;
    // const { navigateInput } = this.state
    const newValue = event.target.value;
    const isAllowed =
      /^\d*$/.test(newValue) && (newValue === "" || parseInt(newValue) >= 1);

    if (isAllowed) {
      if (newValue === "") {
        this.setState({ navigateInput: newValue });
      } else {
        const index =
          event.target.value > itemSelected.document.totalDocumentPages
            ? itemSelected.document.totalDocumentPages
            : event.target.value < 1
            ? 1
            : event.target.value;
        this.setState({ navigateInput: index });
      }
    }
  };

  goToPreviousPage = () => {
    const { currentPage } = this.state;

    if (currentPage - 1) this.handlerSelectFlickity(currentPage - 2);
  };

  goToNextPage = () => {
    const { itemSelected } = this.props;
    const { currentPage } = this.state;
    if (itemSelected.document.totalDocumentPages - Number(currentPage)) {
      this.handlerSelectFlickity(Number(currentPage));
    }
  };

  handlePdfTag = () => {
    const {
      isPdfTagActive,
      setIsPdfTagActive,
      unsetIsPdfTagActive,
      showCommentComponent,
      isShowComments
    } = this.props;

    if (!isShowComments) {
      showCommentComponent();
      setIsPdfTagActive();
    } else {
      if (isPdfTagActive) {
        unsetIsPdfTagActive();
      } else {
        setIsPdfTagActive();
      }
    }
  };

  setFlickityRef = ref => {
    this.flkty = ref;
  };

  render() {
    const { itemSelected, isFetchingPages } = this.props;
    const { exploreIndex, navigateInput, currentPage } = this.state;

    const showLoader =
      isFetchingPages &&
      itemSelected.document.documentPages.length < currentPage;
    return (
      <React.Fragment>
        <PDFViewPresentational
          exploreIndex={exploreIndex}
          currentPage={currentPage}
          navigateInput={navigateInput}
          document={itemSelected.document}
          showLoader={showLoader}
          isReduxAware={true}
          setFlickityRef={this.setFlickityRef}
          handlerSelectFlickity={this.handlerSelectFlickity}
          handlePdfTag={this.handlePdfTag}
          goToPreviousPage={this.goToPreviousPage}
          handleonKeyUp={this.handleonKeyUp}
          handleOnChange2={this.handleOnChange2}
          goToNextPage={this.goToNextPage}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  isPdfTagActive: state.comments.isPdfTagActive,
  selectedIndex: state.comments.pdfCarouselIndex,
  previousPdfCarouselIndex: state.comments.previousPdfCarouselIndex.index,
  isSettingPrevious: state.comments.previousPdfCarouselIndex.isSettingPrevious,
  isPdfTagClicked: state.comments.pdfTagClicked.isClicked,
  newPdfCarouselIndex: state.comments.pdfTagClicked.newPdfCarouselIndex,
  isFetchingPages: state.comments.isFetchingPages
});

const mapDispatchToProps = {
  getPDFPages,
  setIsPdfTagActive,
  unsetIsPdfTagActive,
  setPDFCarouselIndex,
  unsetPdfTagClicked,
  restorePreviosPdfCarrouselIndexSuccess,
  tryGetPDFPages
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PDFViewContainer))
);
